export const firebaseConfig = {
  apiKey: "AIzaSyBie6Qe95zGprtbXu_X2aLi5xZudMzjWdM",
  authDomain: "reactchat-13a37.firebaseapp.com",
  databaseURL: "https://reactchat-13a37.firebaseio.com",
  storageBucket: "reactchat-13a37.appspot.com",
  messagingSenderId: "1044101975651"
};



/** WEBPACK FOOTER **
 ** ./src/firebase_config.js
 **/